import { useContext } from "react";
import { GenerateInvoiceActionContext } from "./GenerateInvoiceActionContext";

function usePrepareGenerateInvoice() {
  const { setShowModal } = useContext(GenerateInvoiceActionContext);
  return () => {
    setShowModal(true);
  };
}

export default usePrepareGenerateInvoice;
